<template>
  <v-snackbar v-model="visible" color="blue darken-2" :timeout="5000" top>
    {{ $t('snackbar-time', {count: $account.current.rules['check-position'].max_monitor_refresh_interval_hours}) }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="visible = false">
        {{ $t('actions.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AccountLimitationForMoreMonitorRefreshNotification',
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    this.$bus.on('notification/account_limitation_for_more_monitor_refresh', () => {
      this.visible = true
    })
  }
}
</script>

<i18n>
{
	"en": {
		"snackbar-time": "Please wait at least {count} hour(s) between each update."
	},
	"es": {
		"snackbar-time": "Espere al menos {count} hora(s) entre cada actualización."
	},
	"fr": {
		"snackbar-time": "Merci de patienter au moins {count} heure(s) entre chaque actualisation."
	},
	"it": {
		"snackbar-time": "Attendi almeno {count} ora/e tra ogni aggiornamento."
	},
	"pt": {
		"snackbar-time": "Por favor aguarde pelo menos {count} hora(s) entre cada atualização."
	},
	"pl": {
		"snackbar-time": "Poczekaj co najmniej {count} godzinę/godziny między każdą aktualizacją."
	}
}
</i18n>
